import {
	Component,
	OnInit,
	Output,
	EventEmitter,
	ViewChild,
	ElementRef,
	AfterViewInit,
	Input,
	OnChanges,
} from '@angular/core';
import { TotBatchService } from 'projects/services/src/app/API/tot-batch.service';
import { ScriptLoaderService } from 'projects/services/src/app/script-loader.service';
import { BatchService } from 'projects/services/src/app/API/batch.service';
import { DateFormatPipe } from 'src/app/pipes/dateformat.pipe';
@Component({
	selector: 'app-tot-toa-filter',
	templateUrl: './tot-toa-filter.component.html',
	styleUrls: ['./tot-toa-filter.component.css'],
	providers: [DateFormatPipe]
})
export class TotToaFilterComponent implements OnInit, AfterViewInit, OnChanges {
	pendingBatch: any;
	@Output() selectedBatchTypes: EventEmitter<any> = new EventEmitter<any>();
	@Output() selectedQpCodes: EventEmitter<any> = new EventEmitter<any>();
	@Output() selectedStates: EventEmitter<any> = new EventEmitter<any>();
	@Output() selectedDistricts: EventEmitter<any> = new EventEmitter<any>();
	@Output() searchText: EventEmitter<any> = new EventEmitter<any>();
	@Output() convertedStartDate: EventEmitter<any> = new EventEmitter<any>();
	@Output() convertedEndDate: EventEmitter<any> = new EventEmitter<any>();
	@Output() selectedScheme: EventEmitter<any> = new EventEmitter<any>();
	@Output() selectedRequest: EventEmitter<any> = new EventEmitter<any>();
	@Output() selectedName: EventEmitter<any> = new EventEmitter<any>();
	@Input() sendStatus: any;
	@Input() showBatchTypes = true;
	@Input() showJobRoles = true;
	@Input() showStates = false;
	@Input() showDistricts = false;
	@Input() showSearchButton = false;
	@Input() showScheme = false;
	@Input() showDates = true;
	@Input() showSearch = true;
	@Input() showRequest = false;
	@Input() showTotName = false;
	@Input() showStatus = false;
	@Input() showSearchText = 'Search by keyword';
	@Input() getUserRole: any;
	@Input() pageNo: any;
	@Input() itemPerPage: any;
	// @Input() searchText: any;
	@ViewChild('startDate') startDate: ElementRef;
	@ViewChild('endDate') endDate: ElementRef;
	@Input() searchData: any;
	@Output() searchDataChange: EventEmitter<any> = new EventEmitter<any>();
	public batchTypes: any;
	dropdownListBatchType: any = [{ item: '', id: 0 }];
	dropdownListQpCode: any = [{ item: '', id: 0 }];
	dropdownListStates: any = [{ item: '', id: 0 }];
	dropdownListDistricts: any = [{ item: '', id: 0 }];
	dropdownListStatus: any = [{ item: '', id: 0 }];
	dropdownListScheme: any = [{ item: '', id: 0 }];
	dropdownListRequest: any = [{ item: '', id: 0 }];
	dropdownListTotName: any = [{ item: '', id: 0 }];
	selectedItemsBatchTypes = [];
	selectedItemsQpCodes = [];
	selectedItemsStates = [];
	selectedItemsDistricts = [];
	selectedItemsScheme = [];
	selectedItemsRequest = [];
	selectedItemsTotName = [];
	filteredData: any;
	dropdownSettingsBatchType = {};
	dropdownSettingsQpCodes = {};
	dropdownSettingsStates = {};
	dropdownSettingsDistricts = {};
	dropdownSettingsScheme = {};
	dropdownSettingsRequest = {};
	dropdownSettingsTotName = {};
	keyword = '';
	constructor(
		private totBatchService: TotBatchService,
		private script: ScriptLoaderService,
		private date: DateFormatPipe,
		private batchService: BatchService
	) { }
	ngOnInit() {
		this.dropdownSettingsBatchType = {
			singleSelection: false,
			text: 'Select Batch Type',
			selectAllText: 'Select All',
			unSelectAllText: 'UnSelect All',
			enableSearchFilter: true,
			classes: 'custom-class'
		};
		this.dropdownSettingsQpCodes = {
			singleSelection: false,
			text: 'Select Job Role',
			selectAllText: 'Select All',
			unSelectAllText: 'UnSelect All',
			enableSearchFilter: true,
			classes: 'custom-class'
		};
		this.dropdownSettingsStates = {
			singleSelection: false,
			text: 'Select State',
			selectAllText: 'Select All',
			unSelectAllText: 'UnSelect All',
			enableSearchFilter: true,
			classes: 'custom-class'
		};
		this.dropdownSettingsDistricts = {
			singleSelection: false,
			text: 'Select District',
			selectAllText: 'Select All',
			unSelectAllText: 'UnSelect All',
			enableSearchFilter: true,
			classes: 'custom-class'
		};
		this.dropdownSettingsScheme = {
			singleSelection: false,
			text: 'Select Scheme',
			selectAllText: 'Select All',
			unSelectAllText: 'UnSelect All',
			enableSearchFilter: true,
			classes: 'custom-class'
		};
		this.dropdownSettingsRequest = {
			singleSelection: false,
			text: 'Select Request Type',
			selectAllText: 'Select All',
			unSelectAllText: 'UnSelect All',
			enableSearchFilter: true,
			classes: 'custom-class'
		};
		this.dropdownSettingsTotName = {
			singleSelection: false,
			text: 'Select ToT/ToA Name',
			selectAllText: 'Select All',
			unSelectAllText: 'UnSelect All',
			enableSearchFilter: true,
			classes: 'custom-class'
		};
	}
	ngAfterViewInit() {
		this.script.loadScripts('app-tot-toa-filter', [
			'./assets/demo/default/custom/components/forms/widgets/bootstrap-datepicker.js'
		]);
	}
	ngOnChanges() { }
	setQpDropdown(qpCodeArray: Array<string>) {
		this.dropdownListQpCode = qpCodeArray.map((code, index) => {
			return { id: index, itemName: code };
		});
		// if (this.dropdownListQpCode.length === 1) {
		// 	this.dropdownListQpCode = [];
		// }
	}
	setStateDropDown(statesArray: Array<string>) {
		this.dropdownListStates = statesArray.map((state, index) => {
			return { id: index, itemName: state };
		});
	}
	setDistrictDropDown(districtArray: Array<string>) {
		this.dropdownListDistricts = districtArray.map((district, index) => {
			return { id: index, itemName: district };
		});
	}
	setSchemeDropDown(schemeArray: Array<string>) {
		this.dropdownListScheme = schemeArray.map((scheme, index) => {
			return { id: index, itemName: scheme };
		});
		console.log(this.dropdownListScheme);
	}
	setTotNameDropDown(schemeArray: Array<string>) {
		this.dropdownListScheme = schemeArray.map((scheme, index) => {
			return { id: index, itemName: scheme };
		});
		console.log(this.dropdownListScheme);
	}
	setRequestDropDown(requestArray: Array<string>) {
		this.dropdownListRequest = requestArray.map((request, index) => {
			return { id: index, itemName: request };
		});
	}
	getBatchTypes() {
		this.totBatchService.getBatchType().subscribe(res => {
			this.dropdownListBatchType = res.batchType.map((lo, index) => {
				return { id: index, itemName: lo };
			});
		});
	}
	resetDates() {
		this.convertedStartDate.emit('');
		this.convertedEndDate.emit('');
		this.startDate.nativeElement.value = '';
		this.endDate.nativeElement.value = '';
		this.searchDataChange.emit('RESET');
		this.getFilteredData();
	}
	onCloseBatchTypeDropdown() {
		this.selectedBatchTypes.emit(this.selectedItemsBatchTypes);
	}
	onCloseQpCodeDropdown() {
		this.selectedQpCodes.emit(this.selectedItemsQpCodes);
	}
	onCloseStatesDropdown() {
		this.selectedStates.emit(this.selectedItemsStates);
	}
	onCloseDistrictsDropdown() {
		console.log(this.dropdownListDistricts);
		this.selectedDistricts.emit(this.selectedItemsDistricts);
	}
	onCloseSchemeDropdown() {
		console.log(this.dropdownListScheme);
		this.selectedScheme.emit(this.selectedItemsScheme);
	}
	onCloseRequestDropdown() {
		console.log(this.dropdownListRequest);
		this.selectedRequest.emit(this.selectedItemsRequest);
	}
	onCloseTotNameDropdown() {
		console.log(this.dropdownListRequest);
		this.selectedName.emit(this.selectedItemsTotName);
	}
	setSearchText(search) {
		this.keyword = search;
		this.searchText.emit(search);
	}
	onCloseStatusDropdown() {

	}
	assignBatchStartDate() {
		if (this.startDate.nativeElement.value.length !== 0) {
			this.convertedStartDate.emit(
				this.date.transform(this.startDate.nativeElement.value)
			);
		}
	}
	assignBatchEndDate() {
		console.log(this.endDate.nativeElement.value);
		if (this.endDate.nativeElement.value.length !== 0) {
			this.convertedEndDate.emit(
				this.date.transform(this.endDate.nativeElement.value)
			);
		}
	}
	getFilteredData() {
		let selectedStartDate;
		let selectedEndDate;
		let searchBasedOnRole;
		const districtArray = Array.prototype.map.call(this.selectedItemsDistricts, d => d.itemName).toString();
		const stateArray = Array.prototype.map.call(this.selectedItemsStates, s => s.itemName).toString();
		const typeArray = Array.prototype.map.call(this.selectedItemsBatchTypes, t => t.itemName).toString();
		const schemeArray = Array.prototype.map.call(this.selectedItemsScheme, s => s.itemName).toString();
		const requestArray = Array.prototype.map.call(this.selectedItemsRequest, s => s.itemName).toString();
		const nameArray = Array.prototype.map.call(this.selectedItemsTotName, s => s.itemName).toString();
		if (this.startDate && this.startDate.nativeElement.value !== '') {
			selectedStartDate = this.startDate.nativeElement.value.split('/').reverse().join('-') + 'T00:00:00.000Z';
			console.log('DateFormat', selectedStartDate);
		}
		if (this.endDate && this.endDate.nativeElement.value !== '') {
			selectedEndDate = this.endDate.nativeElement.value.split('/').reverse().join('-') + 'T00:00:00.000Z';
			console.log('DateFormat', selectedEndDate);
		}
		const data = {
			type: typeArray ? typeArray : '',
			district: districtArray ? districtArray : '',
			state: stateArray ? stateArray : '',
			batchStartDate: selectedStartDate ? selectedStartDate : '',
			batchEndDate: selectedEndDate ? selectedEndDate : '',
			scheme: schemeArray ? schemeArray : '',
			request: requestArray ? requestArray : '',
			name: nameArray ? nameArray : ''
		};
		console.log(data);
		if (this.keyword === '') {
			searchBasedOnRole = '';
		} else {
			if (this.getUserRole.role === 'Assessor') {
				searchBasedOnRole = 'tcName' + ':' + this.keyword;
			} else {
				searchBasedOnRole = 'batchId' + ':' + this.keyword;
			}
		}
		console.log(this.sendStatus);
		const paramData = {
			keyword: searchBasedOnRole,
			batchId: '',
			status: this.sendStatus,
			sortBy: ''
		};
		if (data.type !== '' || data.district !== '' || data.state !== '' || data.batchStartDate !== '' || data.batchEndDate !== '') {
			this.batchService.totSearch(paramData, data).subscribe(res => {
				if (res) {
					this.pendingBatch = res.docs;
					this.searchDataChange.emit(this.pendingBatch);
				}
			}, error => {
				this.pendingBatch = [];
				this.searchDataChange.emit(this.pendingBatch);
			});
		} else {
			console.log(this.sendStatus, this.pageNo, this.itemPerPage, 'SDFGHJKLKJHGFDSASDFgh')
			this.totBatchService.getBatches(this.sendStatus, this.pageNo, this.itemPerPage).subscribe(res => {
				if (res) {
					this.pendingBatch = res.batches;
					this.searchDataChange.emit(this.pendingBatch);
				}
			}, error => {
				this.pendingBatch = [];
				this.searchDataChange.emit(this.pendingBatch);
			});
		}
		console.log('test');
		return this.pendingBatch;
	}
}
